module.exports = __webpack_public_path__ + "static/AD-9965b9a1bbbcaa3abd116b8a2a5594b3.svg";